var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thank-you main-container"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('thank_you_for_joining')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }